import { Modal } from 'antd'
import { useToast } from '@/contexts/ToastContext'
import type { McpConnection } from '@/types/mcp'
import { useRevokeMcpConnectionMutation } from './hooks'

type DisconnectCopy = { title: string; content: string; success: string }

export function useDisconnectConnection() {
  const { addToast } = useToast()
  const revoke = useRevokeMcpConnectionMutation()

  const confirmDisconnect = (connection: McpConnection, copy: DisconnectCopy) =>
    Modal.confirm({
      title: copy.title,
      content: copy.content,
      okText: 'Disconnect',
      okButtonProps: { danger: true },
      onOk: async () => {
        try {
          await revoke.mutateAsync(connection.connectionId)
          addToast(copy.success, 'success')
        } catch (e) {
          addToast(e instanceof Error ? e.message : 'Unable to disconnect', 'error')
        }
      },
    })

  return { confirmDisconnect, disconnectingId: revoke.isPending ? revoke.variables : undefined }
}
